import { render } from "./ChartAnalyticsCorrectnessPeriodic.vue?vue&type=template&id=2e9fb085&scoped=true"
import script from "./ChartAnalyticsCorrectnessPeriodic.vue?vue&type=script&lang=js"
export * from "./ChartAnalyticsCorrectnessPeriodic.vue?vue&type=script&lang=js"

import "@/css/components/chart-analytics-correctness-periodic.css?vue&type=style&index=0&id=2e9fb085&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9fb085"]])

export default __exports__